module.exports = __webpack_public_path__ + "7865db4bc914ad235a72d2621fde0a52.svg";